import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseProjectLink extends BaseModel {
  static override constructorName = 'ResearchShowcaseProjectLink'

  url: string = ''
  title: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseProjectLink)
